module.exports = __webpack_public_path__ + "static/media/question_mark_img.f6ea5b3b.png";